import { SaSmsNumberBilling } from '@interfaces/sa-sms';
import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';

const REG_COLOR: Record<string, string> = {
    approved: 'success',
    rejected: 'error',
    suspended: 'error',
    submitted: 'processing',
    brand_pending: 'processing',
    campaign_pending: 'processing',
    draft: 'default',
    not_started: 'default',
};

/** A2P / sender registration status tag (`registrationStatus` of the sender registry). */
export const RegistrationTag: React.FC<{ status?: string | null }> = ({ status }) => {
    const { t } = useTranslation(['sa-sms']);
    if (!status) return <Tag>{t('status.not_started')}</Tag>;
    return (
        <Tag color={REG_COLOR[status] ?? 'default'}>
            {t(`status.${status}`, { defaultValue: status })}
        </Tag>
    );
};

const BILLING_COLOR: Record<SaSmsNumberBilling, string> = {
    none: 'default',
    active: 'success',
    lapsed: 'error',
};

export const NumberBillingTag: React.FC<{ status: SaSmsNumberBilling }> = ({ status }) => {
    const { t } = useTranslation(['sa-sms']);
    return <Tag color={BILLING_COLOR[status]}>{t(`billing.${status}`)}</Tag>;
};

export const OnOffTag: React.FC<{ on: boolean }> = ({ on }) => {
    const { t } = useTranslation(['sa-sms']);
    return <Tag color={on ? 'success' : 'default'}>{on ? t('common.on') : t('common.off')}</Tag>;
};
